import { DashboardTable } from '../../commonDashboardComponents/DashboardTable'

export const CampaignPerformance = () => {

    const performanceData = [
        {
            campaign: "Summer Sale 2026",
            ctr: "3.2%",
            cpc: "$0.45",
            cpm: "$12.50",
            convRate: "8.7%",
            revenue: "$24,850",
            roas: "4.2x"
        },
        {
            campaign: "Product Launch - Pro",
            ctr: "2.8%",
            cpc: "$0.62",
            cpm: "$15.30",
            convRate: "6.4%",
            revenue: "$18,420",
            roas: "3.8x"
        },
        {
            campaign: "Holiday Special",
            ctr: "4.1%",
            cpc: "$0.38",
            cpm: "$9.75",
            convRate: "11.2%",
            revenue: "$42,100",
            roas: "6.5x"
        },
        {
            campaign: "Brand Awareness Q3",
            ctr: "1.5%",
            cpc: "$0.89",
            cpm: "$22.40",
            convRate: "3.1%",
            revenue: "$8,750",
            roas: "1.9x"
        },
        {
            campaign: "Retargeting Campaign",
            ctr: "5.6%",
            cpc: "$0.28",
            cpm: "$7.20",
            convRate: "14.5%",
            revenue: "$56,300",
            roas: "8.1x"
        },
        {
            campaign: "Social Media Blitz",
            ctr: "3.8%",
            cpc: "$0.51",
            cpm: "$13.80",
            convRate: "9.3%",
            revenue: "$31,675",
            roas: "5.2x"
        },
        {
            campaign: "Email Marketing Q4",
            ctr: "6.2%",
            cpc: "$0.19",
            cpm: "$5.60",
            convRate: "18.6%",
            revenue: "$72,400",
            roas: "12.3x"
        }
    ];

    const performanceTableHeader = () => (<thead style={{ zIndex: 101 }}>
        <tr style={{ background: "#8d8d8d1c", borderBottom: '1px solid #e3e3e3' }}>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                Campaign
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                CTR
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                CPC
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                CPM
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                Conv. Rate
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                Revenue
            </div>
            <div scope="col" className='d-table-cell' style={{ background: 'white', textWrap: 'nowrap', fontSize: '12px' }}>
                ROAS
            </div>
        </tr>
    </thead>)

    const performanceTableBody = () => (<tbody>
        {performanceData.map((data, idx) => (
            <tr key={idx}>
                <td className="fw-semibold text-dark text-start">{data.campaign}</td>
                <td className="text-muted">{data.ctr}</td>
                <td className="text-muted">{data.cpc}</td>
                <td className="fw-semibold text-dark">{data.cpm}</td>
                <td className="fw-semibold text-dark">{data.convRate}</td>
                <td className="fw-semibold text-dark">{data.revenue}</td>
                <td className="fw-semibold text-dark">{data.roas}</td>
            </tr>
        ))}
    </tbody>)


    return (
        <DashboardTable
            title={"Campaign Performance"}
            subheader={"A short Description starts here."}
            tableHeader={performanceTableHeader}
            tableBody={performanceTableBody}
            tableStyles={{ height: "100%", width: "100%" }}
        />
    )
}
